module.exports = __webpack_public_path__ + "img/bx-class-timetable-active.3a1ad39e.svg";